import Immutable from 'immutable';

export const GET_ADDITIONS = 'takeback/api/ADDITIONS';
export const GET_ADDITIONS_SUCCESS = 'takeback/api/ADDITIONS_SUCCESS';
export const GET_ADDITIONS_FAILURE = 'takeback/api/ADDITIONS_FAILURE';

const initialState = Immutable.List();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_ADDITIONS_SUCCESS:
            return new Immutable.List(action.additions);
        default: return state;
    }
}

// Selectors
export function selectAdditions(state) {
    return state.additions;
}

// Actions
export function getAdditions(data, options = {}) {
    return Object.assign({ type: GET_ADDITIONS, data }, options);
}

export function getAdditionsSuccess(additions) {
    return { type: GET_ADDITIONS_SUCCESS, additions };
}

export function getAdditionsFailure(error) {
    return { type: GET_ADDITIONS_FAILURE, error };
}
